//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./sales_insights.d.ts" />

import * as $ from "skir-client";
import * as x_autoresearch from "./autoresearch.js";

// -----------------------------------------------------------------------------
// enum SalesInsightsPhase
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class SalesInsightsPhase extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum SalesInsightsRunStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class SalesInsightsRunStatus extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct PhaseStartedEvent
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `PhaseStartedEvent.Mutable`. */
export class PhaseStartedEvent extends $._FrozenBase {}

function initPhaseStartedEvent(target, initializer) {
  target.seq = initializer.seq ?? 0;
  target.unixMillis = initializer.unixMillis ?? BigInt(0);
  target.phase = SalesInsightsPhase.create(initializer.phase ?? SalesInsightsPhase.UNKNOWN);
  target.label = initializer.label ?? "";
}

// -----------------------------------------------------------------------------
// struct PhaseCompletedEvent
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `PhaseCompletedEvent.Mutable`. */
export class PhaseCompletedEvent extends $._FrozenBase {}

function initPhaseCompletedEvent(target, initializer) {
  target.seq = initializer.seq ?? 0;
  target.unixMillis = initializer.unixMillis ?? BigInt(0);
  target.phase = SalesInsightsPhase.create(initializer.phase ?? SalesInsightsPhase.UNKNOWN);
  target.summary = initializer.summary ?? "";
}

// -----------------------------------------------------------------------------
// struct ToolCallStartedEvent
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ToolCallStartedEvent.Mutable`. */
export class ToolCallStartedEvent extends $._FrozenBase {}

function initToolCallStartedEvent(target, initializer) {
  target.seq = initializer.seq ?? 0;
  target.unixMillis = initializer.unixMillis ?? BigInt(0);
  target.toolName = initializer.toolName ?? "";
  target.argsPreview = initializer.argsPreview ?? "";
}

// -----------------------------------------------------------------------------
// struct ToolCallCompletedEvent
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ToolCallCompletedEvent.Mutable`. */
export class ToolCallCompletedEvent extends $._FrozenBase {}

function initToolCallCompletedEvent(target, initializer) {
  target.seq = initializer.seq ?? 0;
  target.unixMillis = initializer.unixMillis ?? BigInt(0);
  target.toolName = initializer.toolName ?? "";
  target.resultPreview = initializer.resultPreview ?? "";
}

// -----------------------------------------------------------------------------
// struct ReasoningTokenEvent
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ReasoningTokenEvent.Mutable`. */
export class ReasoningTokenEvent extends $._FrozenBase {}

function initReasoningTokenEvent(target, initializer) {
  target.seq = initializer.seq ?? 0;
  target.unixMillis = initializer.unixMillis ?? BigInt(0);
  target.text = initializer.text ?? "";
}

// -----------------------------------------------------------------------------
// struct SalesInsightsErrorEvent
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `SalesInsightsErrorEvent.Mutable`. */
export class SalesInsightsErrorEvent extends $._FrozenBase {}

function initSalesInsightsErrorEvent(target, initializer) {
  target.seq = initializer.seq ?? 0;
  target.unixMillis = initializer.unixMillis ?? BigInt(0);
  target.message = initializer.message ?? "";
}

// -----------------------------------------------------------------------------
// enum SalesInsightsProgressEvent
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class SalesInsightsProgressEvent extends $._EnumBase {}

function createValueOfSalesInsightsProgressEvent(initializer) {
  const { kind, value } = initializer;
  switch (kind) {
    case "phase_started": {
      return PhaseStartedEvent.create(value);
    }
    case "phase_completed": {
      return PhaseCompletedEvent.create(value);
    }
    case "tool_call_started": {
      return ToolCallStartedEvent.create(value);
    }
    case "tool_call_completed": {
      return ToolCallCompletedEvent.create(value);
    }
    case "reasoning_token": {
      return ReasoningTokenEvent.create(value);
    }
    case "error": {
      return SalesInsightsErrorEvent.create(value);
    }
  }
}

// -----------------------------------------------------------------------------
// struct SalesInsightsRunSummary
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `SalesInsightsRunSummary.Mutable`. */
export class SalesInsightsRunSummary extends $._FrozenBase {}

function initSalesInsightsRunSummary(target, initializer) {
  target.runId = initializer.runId ?? "";
  target.status = SalesInsightsRunStatus.create(initializer.status ?? SalesInsightsRunStatus.UNKNOWN);
  target.triggeredByUserId = initializer.triggeredByUserId ?? "";
  target.startedAtUnixMillis = initializer.startedAtUnixMillis ?? BigInt(0);
  target.completedAtUnixMillis = initializer.completedAtUnixMillis ?? BigInt(0);
  target.lastPhase = initializer.lastPhase ? SalesInsightsPhase.create(initializer.lastPhase) : null;
  target.errorMessage = initializer.errorMessage ?? "";
  target.hypothesisCount = initializer.hypothesisCount ?? 0;
}

// -----------------------------------------------------------------------------
// struct SalesInsightsRunDetail
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `SalesInsightsRunDetail.Mutable`. */
export class SalesInsightsRunDetail extends $._FrozenBase {}

function initSalesInsightsRunDetail(target, initializer) {
  target.summary = SalesInsightsRunSummary.create(initializer.summary ?? SalesInsightsRunSummary.DEFAULT);
  target.events = $._toFrozenArray(
    initializer.events || [],
    SalesInsightsProgressEvent.create,
  );
}

// -----------------------------------------------------------------------------
// enum SalesInsightsFindingStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class SalesInsightsFindingStatus extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum SalesInsightsFindingImpact
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class SalesInsightsFindingImpact extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct SalesInsightsMonitorTarget
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `SalesInsightsMonitorTarget.Mutable`. */
export class SalesInsightsMonitorTarget extends $._FrozenBase {}

function initSalesInsightsMonitorTarget(target, initializer) {
  target.taxonomyCategories = $._toFrozenArray(
    initializer.taxonomyCategories || []);
    target.dealStage = initializer.dealStage ?? "";
    target.dataWindowDays = initializer.dataWindowDays ?? 0;
    target.baselineCallsAffected = initializer.baselineCallsAffected ?? 0;
    target.baselineTotalCalls = initializer.baselineTotalCalls ?? 0;
    target.baselineWinRate = initializer.baselineWinRate ?? 0;
    target.baselineAvgCycleDays = initializer.baselineAvgCycleDays ?? 0;
    target.baselineUnixMillis = initializer.baselineUnixMillis ?? BigInt(0);
    target.successMetricLabel = initializer.successMetricLabel ?? "";
    target.subjectLabel = initializer.subjectLabel ?? "";
    target.competitorFilter = $._toFrozenArray(
      initializer.competitorFilter || []);
      target.repEmailFilter = $._toFrozenArray(
        initializer.repEmailFilter || []);
        target.baselinePending = initializer.baselinePending ?? false;
        target.metric = x_autoresearch.AutoResearchMetric.create(initializer.metric ?? x_autoresearch.AutoResearchMetric.UNKNOWN);
        target.expectedEvaluationCount = initializer.expectedEvaluationCount ?? 0;
}

// -----------------------------------------------------------------------------
// struct MonitoredFindingEvaluationEvidence
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MonitoredFindingEvaluationEvidence.Mutable`. */
export class MonitoredFindingEvaluationEvidence extends $._FrozenBase {}

function initMonitoredFindingEvaluationEvidence(target, initializer) {
  target.meetingOffsetSeconds = initializer.meetingOffsetSeconds ?? 0;
  target.speaker = initializer.speaker ?? "";
  target.quote = initializer.quote ?? "";
}

// -----------------------------------------------------------------------------
// struct MonitoredFindingEvaluation
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MonitoredFindingEvaluation.Mutable`. */
export class MonitoredFindingEvaluation extends $._FrozenBase {}

function initMonitoredFindingEvaluation(target, initializer) {
  target.findingId = initializer.findingId ?? "";
  target.meetingId = initializer.meetingId ?? "";
  target.discussed = initializer.discussed ?? false;
  target.success = initializer.success ?? null;
  target.evidence = $._toFrozenArray(
    initializer.evidence || [],
    MonitoredFindingEvaluationEvidence.create,
  );
  target.dealStageAtMeeting = initializer.dealStageAtMeeting ?? "";
  target.dealId = initializer.dealId ?? "";
  target.repEmail = initializer.repEmail ?? "";
  target.competitorCited = initializer.competitorCited ?? "";
  target.evaluatedUnixMillis = initializer.evaluatedUnixMillis ?? BigInt(0);
}

// -----------------------------------------------------------------------------
// struct MonitoredFindingKpiCard
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MonitoredFindingKpiCard.Mutable`. */
export class MonitoredFindingKpiCard extends $._FrozenBase {}

function initMonitoredFindingKpiCard(target, initializer) {
  target.label = initializer.label ?? "";
  target.value = initializer.value ?? "";
  target.deltaLabel = initializer.deltaLabel ?? "";
  target.deltaPositive = initializer.deltaPositive ?? false;
  target.sparkline = $._toFrozenArray(
    initializer.sparkline || []);
}

// -----------------------------------------------------------------------------
// struct MonitoredFindingStackedTimePoint
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MonitoredFindingStackedTimePoint.Mutable`. */
export class MonitoredFindingStackedTimePoint extends $._FrozenBase {}

function initMonitoredFindingStackedTimePoint(target, initializer) {
  target.bucketLabel = initializer.bucketLabel ?? "";
  target.bucketStartUnixMillis = initializer.bucketStartUnixMillis ?? BigInt(0);
  target.successCount = initializer.successCount ?? 0;
  target.failureCount = initializer.failureCount ?? 0;
  target.notDiscussedCount = initializer.notDiscussedCount ?? 0;
}

// -----------------------------------------------------------------------------
// struct MonitoredFindingBreakdownRow
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MonitoredFindingBreakdownRow.Mutable`. */
export class MonitoredFindingBreakdownRow extends $._FrozenBase {}

function initMonitoredFindingBreakdownRow(target, initializer) {
  target.label = initializer.label ?? "";
  target.discussedCount = initializer.discussedCount ?? 0;
  target.successCount = initializer.successCount ?? 0;
  target.successRate = initializer.successRate ?? 0;
  target.winRate = initializer.winRate ?? 0;
  target.successRateDeltaPts = initializer.successRateDeltaPts ?? 0;
  target.winRateDeltaPts = initializer.winRateDeltaPts ?? 0;
}

// -----------------------------------------------------------------------------
// struct MonitoredFindingBreakdown
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MonitoredFindingBreakdown.Mutable`. */
export class MonitoredFindingBreakdown extends $._FrozenBase {}

function initMonitoredFindingBreakdown(target, initializer) {
  target.title = initializer.title ?? "";
  target.rows = $._toFrozenArray(
    initializer.rows || [],
    MonitoredFindingBreakdownRow.create,
  );
}

// -----------------------------------------------------------------------------
// struct MonitoredFindingBeforeAfter
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MonitoredFindingBeforeAfter.Mutable`. */
export class MonitoredFindingBeforeAfter extends $._FrozenBase {}

function initMonitoredFindingBeforeAfter(target, initializer) {
  target.beforeLabel = initializer.beforeLabel ?? "";
  target.afterLabel = initializer.afterLabel ?? "";
  target.beforeSuccessRate = initializer.beforeSuccessRate ?? 0;
  target.afterSuccessRate = initializer.afterSuccessRate ?? 0;
  target.beforeWinRate = initializer.beforeWinRate ?? 0;
  target.afterWinRate = initializer.afterWinRate ?? 0;
  target.beforeAvgCycleDays = initializer.beforeAvgCycleDays ?? 0;
  target.afterAvgCycleDays = initializer.afterAvgCycleDays ?? 0;
  target.beforeAvgDealSize = initializer.beforeAvgDealSize ?? 0;
  target.afterAvgDealSize = initializer.afterAvgDealSize ?? 0;
}

// -----------------------------------------------------------------------------
// struct MonitoredFindingOutcomeRow
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MonitoredFindingOutcomeRow.Mutable`. */
export class MonitoredFindingOutcomeRow extends $._FrozenBase {}

function initMonitoredFindingOutcomeRow(target, initializer) {
  target.label = initializer.label ?? "";
  target.valueWhenDiscussed = initializer.valueWhenDiscussed ?? "";
  target.valueGlobal = initializer.valueGlobal ?? "";
  target.rateWhenDiscussed = initializer.rateWhenDiscussed ?? 0;
  target.rateGlobal = initializer.rateGlobal ?? 0;
}

// -----------------------------------------------------------------------------
// struct MonitoredFindingOutcomeCard
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MonitoredFindingOutcomeCard.Mutable`. */
export class MonitoredFindingOutcomeCard extends $._FrozenBase {}

function initMonitoredFindingOutcomeCard(target, initializer) {
  target.title = initializer.title ?? "";
  target.subtitle = initializer.subtitle ?? "";
  target.rows = $._toFrozenArray(
    initializer.rows || [],
    MonitoredFindingOutcomeRow.create,
  );
}

// -----------------------------------------------------------------------------
// struct MonitoredFindingMeetingEvidence
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MonitoredFindingMeetingEvidence.Mutable`. */
export class MonitoredFindingMeetingEvidence extends $._FrozenBase {}

function initMonitoredFindingMeetingEvidence(target, initializer) {
  target.meetingId = initializer.meetingId ?? "";
  target.meetingTitle = initializer.meetingTitle ?? "";
  target.meetingStartUnixMillis = initializer.meetingStartUnixMillis ?? BigInt(0);
  target.dealName = initializer.dealName ?? "";
  target.repEmail = initializer.repEmail ?? "";
  target.discussed = initializer.discussed ?? false;
  target.success = initializer.success ?? null;
  target.evidence = $._toFrozenArray(
    initializer.evidence || [],
    MonitoredFindingEvaluationEvidence.create,
  );
}

// -----------------------------------------------------------------------------
// struct MonitoredFindingDashboard
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MonitoredFindingDashboard.Mutable`. */
export class MonitoredFindingDashboard extends $._FrozenBase {}

function initMonitoredFindingDashboard(target, initializer) {
  target.findingId = initializer.findingId ?? "";
  target.baselinePending = initializer.baselinePending ?? false;
  target.baselineProgressEvaluated = initializer.baselineProgressEvaluated ?? 0;
  target.baselineProgressTotal = initializer.baselineProgressTotal ?? 0;
  target.narrativeBullets = $._toFrozenArray(
    initializer.narrativeBullets || []);
    target.narrativeGeneratedUnixMillis = initializer.narrativeGeneratedUnixMillis ?? BigInt(0);
    target.kpiCards = $._toFrozenArray(
      initializer.kpiCards || [],
      MonitoredFindingKpiCard.create,
    );
    target.timeSeries = $._toFrozenArray(
      initializer.timeSeries || [],
      MonitoredFindingStackedTimePoint.create,
    );
    target.breakdowns = $._toFrozenArray(
      initializer.breakdowns || [],
      MonitoredFindingBreakdown.create,
    );
    target.beforeAfter = initializer.beforeAfter ? MonitoredFindingBeforeAfter.create(initializer.beforeAfter) : null;
    target.baselineProgressFailed = initializer.baselineProgressFailed ?? 0;
    target.outcomeCard = initializer.outcomeCard ? MonitoredFindingOutcomeCard.create(initializer.outcomeCard) : null;
    target.promptPreview = initializer.promptPreview ?? "";
    target.evidenceMeetings = $._toFrozenArray(
      initializer.evidenceMeetings || [],
      MonitoredFindingMeetingEvidence.create,
    );
}

// -----------------------------------------------------------------------------
// struct SalesInsightsFinding
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `SalesInsightsFinding.Mutable`. */
export class SalesInsightsFinding extends $._FrozenBase {}

function initSalesInsightsFinding(target, initializer) {
  target.id = initializer.id ?? "";
  target.runId = initializer.runId ?? "";
  target.status = SalesInsightsFindingStatus.create(initializer.status ?? SalesInsightsFindingStatus.UNKNOWN);
  target.impact = SalesInsightsFindingImpact.create(initializer.impact ?? SalesInsightsFindingImpact.UNKNOWN);
  target.title = initializer.title ?? "";
  target.body = initializer.body ?? "";
  target.callsAffected = initializer.callsAffected ?? 0;
  target.totalCalls = initializer.totalCalls ?? 0;
  target.winRateDeltaPts = initializer.winRateDeltaPts ?? 0;
  target.cycleLengthDeltaDays = initializer.cycleLengthDeltaDays ?? 0;
  target.confidence = initializer.confidence ?? 0;
  target.recommendedActionTitle = initializer.recommendedActionTitle ?? "";
  target.recommendedActionBody = initializer.recommendedActionBody ?? "";
  target.recommendedActionStage = initializer.recommendedActionStage ?? "";
  target.monitorTarget = initializer.monitorTarget ? SalesInsightsMonitorTarget.create(initializer.monitorTarget) : null;
  target.createdUnixMillis = initializer.createdUnixMillis ?? BigInt(0);
  target.updatedUnixMillis = initializer.updatedUnixMillis ?? BigInt(0);
  target.evidenceFor = $._toFrozenArray(
    initializer.evidenceFor || [],
    x_autoresearch.HypothesisEvidence.create,
  );
  target.evidenceAgainst = $._toFrozenArray(
    initializer.evidenceAgainst || [],
    x_autoresearch.HypothesisEvidence.create,
  );
  target.cohort = initializer.cohort ? x_autoresearch.HypothesisCohort.create(initializer.cohort) : null;
  target.cohortNDeals = initializer.cohortNDeals ?? 0;
  target.cohortNCalls = initializer.cohortNCalls ?? 0;
  target.claimComponents = $._toFrozenArray(
    initializer.claimComponents || [],
    x_autoresearch.ClaimComponent.create,
  );
  target.winRateDeltaLowerCi95Pts = initializer.winRateDeltaLowerCi95Pts ?? 0;
  target.winRateDeltaUpperCi95Pts = initializer.winRateDeltaUpperCi95Pts ?? 0;
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "sales_insights.skir",
  [
    {
      kind: "enum",
      ctor: SalesInsightsPhase,
      name: "SalesInsightsPhase",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "ANALYZING_CALLS",
          number: 1,
        },
        {
          name: "MATCHING_CRM",
          number: 2,
        },
        {
          name: "DETECTING_PATTERNS",
          number: 3,
        },
        {
          name: "FINALIZING",
          number: 4,
        },
      ],
    },
    {
      kind: "enum",
      ctor: SalesInsightsRunStatus,
      name: "SalesInsightsRunStatus",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "PENDING",
          number: 1,
        },
        {
          name: "RUNNING",
          number: 2,
        },
        {
          name: "COMPLETED",
          number: 3,
        },
        {
          name: "FAILED",
          number: 4,
        },
        {
          name: "CANCELLED",
          number: 5,
        },
      ],
    },
    {
      kind: "struct",
      ctor: PhaseStartedEvent,
      initFn: initPhaseStartedEvent,
      name: "PhaseStartedEvent",
      fields: [
        {
          name: "seq",
          property: "seq",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "unix_millis",
          property: "unixMillis",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "phase",
          property: "phase",
          number: 2,
          type: {
            kind: "record",
            ctor: SalesInsightsPhase,
          },
        },
        {
          name: "label",
          property: "label",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: PhaseCompletedEvent,
      initFn: initPhaseCompletedEvent,
      name: "PhaseCompletedEvent",
      fields: [
        {
          name: "seq",
          property: "seq",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "unix_millis",
          property: "unixMillis",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "phase",
          property: "phase",
          number: 2,
          type: {
            kind: "record",
            ctor: SalesInsightsPhase,
          },
        },
        {
          name: "summary",
          property: "summary",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ToolCallStartedEvent,
      initFn: initToolCallStartedEvent,
      name: "ToolCallStartedEvent",
      fields: [
        {
          name: "seq",
          property: "seq",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "unix_millis",
          property: "unixMillis",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "tool_name",
          property: "toolName",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "args_preview",
          property: "argsPreview",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ToolCallCompletedEvent,
      initFn: initToolCallCompletedEvent,
      name: "ToolCallCompletedEvent",
      fields: [
        {
          name: "seq",
          property: "seq",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "unix_millis",
          property: "unixMillis",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "tool_name",
          property: "toolName",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "result_preview",
          property: "resultPreview",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ReasoningTokenEvent,
      initFn: initReasoningTokenEvent,
      name: "ReasoningTokenEvent",
      fields: [
        {
          name: "seq",
          property: "seq",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "unix_millis",
          property: "unixMillis",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "text",
          property: "text",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: SalesInsightsErrorEvent,
      initFn: initSalesInsightsErrorEvent,
      name: "SalesInsightsErrorEvent",
      fields: [
        {
          name: "seq",
          property: "seq",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "unix_millis",
          property: "unixMillis",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "message",
          property: "message",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: SalesInsightsProgressEvent,
      createValueFn: createValueOfSalesInsightsProgressEvent,
      name: "SalesInsightsProgressEvent",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "phase_started",
          number: 1,
          type: {
            kind: "record",
            ctor: PhaseStartedEvent,
          },
        },
        {
          name: "phase_completed",
          number: 2,
          type: {
            kind: "record",
            ctor: PhaseCompletedEvent,
          },
        },
        {
          name: "tool_call_started",
          number: 3,
          type: {
            kind: "record",
            ctor: ToolCallStartedEvent,
          },
        },
        {
          name: "tool_call_completed",
          number: 4,
          type: {
            kind: "record",
            ctor: ToolCallCompletedEvent,
          },
        },
        {
          name: "reasoning_token",
          number: 5,
          type: {
            kind: "record",
            ctor: ReasoningTokenEvent,
          },
        },
        {
          name: "error",
          number: 6,
          type: {
            kind: "record",
            ctor: SalesInsightsErrorEvent,
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: SalesInsightsRunSummary,
      initFn: initSalesInsightsRunSummary,
      name: "SalesInsightsRunSummary",
      fields: [
        {
          name: "run_id",
          property: "runId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "status",
          property: "status",
          number: 1,
          type: {
            kind: "record",
            ctor: SalesInsightsRunStatus,
          },
        },
        {
          name: "triggered_by_user_id",
          property: "triggeredByUserId",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "started_at_unix_millis",
          property: "startedAtUnixMillis",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "completed_at_unix_millis",
          property: "completedAtUnixMillis",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "last_phase",
          property: "lastPhase",
          number: 5,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: SalesInsightsPhase,
            },
          },
        },
        {
          name: "error_message",
          property: "errorMessage",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "hypothesis_count",
          property: "hypothesisCount",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: SalesInsightsRunDetail,
      initFn: initSalesInsightsRunDetail,
      name: "SalesInsightsRunDetail",
      fields: [
        {
          name: "summary",
          property: "summary",
          number: 0,
          type: {
            kind: "record",
            ctor: SalesInsightsRunSummary,
          },
          mutableGetter: "mutableSummary",
        },
        {
          name: "events",
          property: "events",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: SalesInsightsProgressEvent,
            },
          },
          mutableGetter: "mutableEvents",
        },
      ],
    },
    {
      kind: "enum",
      ctor: SalesInsightsFindingStatus,
      name: "SalesInsightsFindingStatus",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "NEW",
          number: 1,
        },
        {
          name: "MONITORED",
          number: 2,
        },
        {
          name: "DISMISSED",
          number: 3,
        },
      ],
    },
    {
      kind: "enum",
      ctor: SalesInsightsFindingImpact,
      name: "SalesInsightsFindingImpact",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "LOW",
          number: 1,
        },
        {
          name: "MEDIUM",
          number: 2,
        },
        {
          name: "HIGH",
          number: 3,
        },
      ],
    },
    {
      kind: "struct",
      ctor: SalesInsightsMonitorTarget,
      initFn: initSalesInsightsMonitorTarget,
      name: "SalesInsightsMonitorTarget",
      fields: [
        {
          name: "taxonomy_categories",
          property: "taxonomyCategories",
          number: 0,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableTaxonomyCategories",
        },
        {
          name: "deal_stage",
          property: "dealStage",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "data_window_days",
          property: "dataWindowDays",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "baseline_calls_affected",
          property: "baselineCallsAffected",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "baseline_total_calls",
          property: "baselineTotalCalls",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "baseline_win_rate",
          property: "baselineWinRate",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "baseline_avg_cycle_days",
          property: "baselineAvgCycleDays",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "baseline_unix_millis",
          property: "baselineUnixMillis",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "success_metric_label",
          property: "successMetricLabel",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "subject_label",
          property: "subjectLabel",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "competitor_filter",
          property: "competitorFilter",
          number: 10,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableCompetitorFilter",
        },
        {
          name: "rep_email_filter",
          property: "repEmailFilter",
          number: 11,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableRepEmailFilter",
        },
        {
          name: "baseline_pending",
          property: "baselinePending",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "metric",
          property: "metric",
          number: 13,
          type: {
            kind: "record",
            ctor: x_autoresearch.AutoResearchMetric,
          },
        },
        {
          name: "expected_evaluation_count",
          property: "expectedEvaluationCount",
          number: 14,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MonitoredFindingEvaluationEvidence,
      initFn: initMonitoredFindingEvaluationEvidence,
      name: "MonitoredFindingEvaluationEvidence",
      fields: [
        {
          name: "meeting_offset_seconds",
          property: "meetingOffsetSeconds",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "speaker",
          property: "speaker",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "quote",
          property: "quote",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MonitoredFindingEvaluation,
      initFn: initMonitoredFindingEvaluation,
      name: "MonitoredFindingEvaluation",
      fields: [
        {
          name: "finding_id",
          property: "findingId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "meeting_id",
          property: "meetingId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "discussed",
          property: "discussed",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "success",
          property: "success",
          number: 3,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "bool",
            },
          },
        },
        {
          name: "evidence",
          property: "evidence",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MonitoredFindingEvaluationEvidence,
            },
          },
          mutableGetter: "mutableEvidence",
        },
        {
          name: "deal_stage_at_meeting",
          property: "dealStageAtMeeting",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "deal_id",
          property: "dealId",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "rep_email",
          property: "repEmail",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "competitor_cited",
          property: "competitorCited",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "evaluated_unix_millis",
          property: "evaluatedUnixMillis",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MonitoredFindingKpiCard,
      initFn: initMonitoredFindingKpiCard,
      name: "MonitoredFindingKpiCard",
      fields: [
        {
          name: "label",
          property: "label",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "value",
          property: "value",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "delta_label",
          property: "deltaLabel",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "delta_positive",
          property: "deltaPositive",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "sparkline",
          property: "sparkline",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "float64",
            },
          },
          mutableGetter: "mutableSparkline",
        },
      ],
    },
    {
      kind: "struct",
      ctor: MonitoredFindingStackedTimePoint,
      initFn: initMonitoredFindingStackedTimePoint,
      name: "MonitoredFindingStackedTimePoint",
      fields: [
        {
          name: "bucket_label",
          property: "bucketLabel",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "bucket_start_unix_millis",
          property: "bucketStartUnixMillis",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "success_count",
          property: "successCount",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "failure_count",
          property: "failureCount",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "not_discussed_count",
          property: "notDiscussedCount",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MonitoredFindingBreakdownRow,
      initFn: initMonitoredFindingBreakdownRow,
      name: "MonitoredFindingBreakdownRow",
      fields: [
        {
          name: "label",
          property: "label",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "discussed_count",
          property: "discussedCount",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "success_count",
          property: "successCount",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "success_rate",
          property: "successRate",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "win_rate",
          property: "winRate",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "success_rate_delta_pts",
          property: "successRateDeltaPts",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "win_rate_delta_pts",
          property: "winRateDeltaPts",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MonitoredFindingBreakdown,
      initFn: initMonitoredFindingBreakdown,
      name: "MonitoredFindingBreakdown",
      fields: [
        {
          name: "title",
          property: "title",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "rows",
          property: "rows",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MonitoredFindingBreakdownRow,
            },
          },
          mutableGetter: "mutableRows",
        },
      ],
    },
    {
      kind: "struct",
      ctor: MonitoredFindingBeforeAfter,
      initFn: initMonitoredFindingBeforeAfter,
      name: "MonitoredFindingBeforeAfter",
      fields: [
        {
          name: "before_label",
          property: "beforeLabel",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "after_label",
          property: "afterLabel",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "before_success_rate",
          property: "beforeSuccessRate",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "after_success_rate",
          property: "afterSuccessRate",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "before_win_rate",
          property: "beforeWinRate",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "after_win_rate",
          property: "afterWinRate",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "before_avg_cycle_days",
          property: "beforeAvgCycleDays",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "after_avg_cycle_days",
          property: "afterAvgCycleDays",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "before_avg_deal_size",
          property: "beforeAvgDealSize",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "after_avg_deal_size",
          property: "afterAvgDealSize",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MonitoredFindingOutcomeRow,
      initFn: initMonitoredFindingOutcomeRow,
      name: "MonitoredFindingOutcomeRow",
      fields: [
        {
          name: "label",
          property: "label",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "value_when_discussed",
          property: "valueWhenDiscussed",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "value_global",
          property: "valueGlobal",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "rate_when_discussed",
          property: "rateWhenDiscussed",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "rate_global",
          property: "rateGlobal",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MonitoredFindingOutcomeCard,
      initFn: initMonitoredFindingOutcomeCard,
      name: "MonitoredFindingOutcomeCard",
      fields: [
        {
          name: "title",
          property: "title",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "subtitle",
          property: "subtitle",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "rows",
          property: "rows",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MonitoredFindingOutcomeRow,
            },
          },
          mutableGetter: "mutableRows",
        },
      ],
    },
    {
      kind: "struct",
      ctor: MonitoredFindingMeetingEvidence,
      initFn: initMonitoredFindingMeetingEvidence,
      name: "MonitoredFindingMeetingEvidence",
      fields: [
        {
          name: "meeting_id",
          property: "meetingId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "meeting_title",
          property: "meetingTitle",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "meeting_start_unix_millis",
          property: "meetingStartUnixMillis",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "deal_name",
          property: "dealName",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "rep_email",
          property: "repEmail",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "discussed",
          property: "discussed",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "success",
          property: "success",
          number: 6,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "bool",
            },
          },
        },
        {
          name: "evidence",
          property: "evidence",
          number: 7,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MonitoredFindingEvaluationEvidence,
            },
          },
          mutableGetter: "mutableEvidence",
        },
      ],
    },
    {
      kind: "struct",
      ctor: MonitoredFindingDashboard,
      initFn: initMonitoredFindingDashboard,
      name: "MonitoredFindingDashboard",
      fields: [
        {
          name: "finding_id",
          property: "findingId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "baseline_pending",
          property: "baselinePending",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "baseline_progress_evaluated",
          property: "baselineProgressEvaluated",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "baseline_progress_total",
          property: "baselineProgressTotal",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "narrative_bullets",
          property: "narrativeBullets",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableNarrativeBullets",
        },
        {
          name: "narrative_generated_unix_millis",
          property: "narrativeGeneratedUnixMillis",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "kpi_cards",
          property: "kpiCards",
          number: 6,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MonitoredFindingKpiCard,
            },
          },
          mutableGetter: "mutableKpiCards",
        },
        {
          name: "time_series",
          property: "timeSeries",
          number: 7,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MonitoredFindingStackedTimePoint,
            },
          },
          mutableGetter: "mutableTimeSeries",
        },
        {
          name: "breakdowns",
          property: "breakdowns",
          number: 8,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MonitoredFindingBreakdown,
            },
          },
          mutableGetter: "mutableBreakdowns",
        },
        {
          name: "before_after",
          property: "beforeAfter",
          number: 9,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: MonitoredFindingBeforeAfter,
            },
          },
        },
        {
          name: "baseline_progress_failed",
          property: "baselineProgressFailed",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "outcome_card",
          property: "outcomeCard",
          number: 11,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: MonitoredFindingOutcomeCard,
            },
          },
        },
        {
          name: "prompt_preview",
          property: "promptPreview",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "evidence_meetings",
          property: "evidenceMeetings",
          number: 13,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MonitoredFindingMeetingEvidence,
            },
          },
          mutableGetter: "mutableEvidenceMeetings",
        },
      ],
    },
    {
      kind: "struct",
      ctor: SalesInsightsFinding,
      initFn: initSalesInsightsFinding,
      name: "SalesInsightsFinding",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "run_id",
          property: "runId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "status",
          property: "status",
          number: 2,
          type: {
            kind: "record",
            ctor: SalesInsightsFindingStatus,
          },
        },
        {
          name: "impact",
          property: "impact",
          number: 3,
          type: {
            kind: "record",
            ctor: SalesInsightsFindingImpact,
          },
        },
        {
          name: "title",
          property: "title",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "body",
          property: "body",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "calls_affected",
          property: "callsAffected",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "total_calls",
          property: "totalCalls",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "win_rate_delta_pts",
          property: "winRateDeltaPts",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "cycle_length_delta_days",
          property: "cycleLengthDeltaDays",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "confidence",
          property: "confidence",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "recommended_action_title",
          property: "recommendedActionTitle",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "recommended_action_body",
          property: "recommendedActionBody",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "recommended_action_stage",
          property: "recommendedActionStage",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "monitor_target",
          property: "monitorTarget",
          number: 14,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: SalesInsightsMonitorTarget,
            },
          },
        },
        {
          name: "created_unix_millis",
          property: "createdUnixMillis",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "updated_unix_millis",
          property: "updatedUnixMillis",
          number: 16,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "evidence_for",
          property: "evidenceFor",
          number: 17,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: x_autoresearch.HypothesisEvidence,
            },
          },
          mutableGetter: "mutableEvidenceFor",
        },
        {
          name: "evidence_against",
          property: "evidenceAgainst",
          number: 18,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: x_autoresearch.HypothesisEvidence,
            },
          },
          mutableGetter: "mutableEvidenceAgainst",
        },
        {
          name: "cohort",
          property: "cohort",
          number: 19,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: x_autoresearch.HypothesisCohort,
            },
          },
        },
        {
          name: "cohort_n_deals",
          property: "cohortNDeals",
          number: 20,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "cohort_n_calls",
          property: "cohortNCalls",
          number: 21,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "claim_components",
          property: "claimComponents",
          number: 22,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: x_autoresearch.ClaimComponent,
            },
          },
          mutableGetter: "mutableClaimComponents",
        },
        {
          name: "win_rate_delta_lower_ci95_pts",
          property: "winRateDeltaLowerCi95Pts",
          number: 23,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "win_rate_delta_upper_ci95_pts",
          property: "winRateDeltaUpperCi95Pts",
          number: 24,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
      ],
    },
  ]
);
